import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";
import styles from "./RewardSummaryCard.module.scss";

const RewardSummaryCardSkeleton: React.FC = () => {
  return (
    <Box className={styles.container}>
      <Box className={styles.tierCircle}>
        <Box className={styles.ellipseWrapper}>
          <Box className={styles.ellipseInner}>
            <Skeleton variant="circular" width={60} height={60} />
          </Box>
        </Box>
      </Box>
      <Typography
        variant="bodySmall"
        color="secondary.main"
        textAlign="center"
        component="div"
      >
        <Skeleton width="60%" sx={{ mx: "auto" }} />
      </Typography>

      <Typography variant="h3" mb={2} textAlign="center">
        <Skeleton width="40%" sx={{ mx: "auto" }} />
      </Typography>

      <Box mb={2} mt={3}>
        <Box display="flex" alignItems="center" mb={1}>
          <Skeleton width={40} height={24} />
          <Skeleton width={40} height={20} sx={{ mx: 1 }} />
          <Box flexGrow={1} />
          <Skeleton width="30%" height={20} />
        </Box>

        <Skeleton variant="rectangular" height={12} width="100%" />
      </Box>
    </Box>
  );
};

export default RewardSummaryCardSkeleton;
